import en from './locales/en.json' with { type: 'json' };
import am from './locales/am.json' with { type: 'json' };
export const catalogs = {
    en,
    am,
};
export function getTranslation(locale, section, key) {
    const cat = catalogs[locale] || catalogs.en;
    const sec = cat[section];
    return sec?.[key] ?? catalogs.en[section]?.[key] ?? key;
}
//# sourceMappingURL=index.js.map